/**
 * Utility functions for pet-related operations
 */

/**
 * Generates a friendly slug from a pet name
 * This matches the slugify function used in the Sanity schema
 */
export function generateSlugFromName(name: string): string {
  return name
    .toString()
    .toLowerCase()
    .trim()
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
}

/**
 * Gets the best identifier for a pet URL
 * Prioritizes slug over UUID for SEO-friendly URLs
 */
export function getPetUrlIdentifier(pet: { slug?: { current: string }; _id: string; name: string }): string {
  // If pet has a slug, use it
  if (pet.slug?.current) {
    return pet.slug.current;
  }
  
  // Fallback: generate slug from name
  return generateSlugFromName(pet.name);
}

/**
 * Generates a complete pet URL path
 */
export function getPetUrlPath(pet: { slug?: { current: string }; _id: string; name: string }): string {
  return `/zwierze/${getPetUrlIdentifier(pet)}`;
}

/**
 * Generates a complete pet URL with domain
 */
export function getPetFullUrl(pet: { slug?: { current: string }; _id: string; name: string }): string {
  return `${window.location.origin}${getPetUrlPath(pet)}`;
}
